/** Default value is LEAD */
export enum EntryKind {
  LEAD = "LEAD",
  CONTACT = "CONTACT",
  JUNK = "JUNK",
}
